import { MessageCircle } from "lucide-react";
import { cn } from "@/lib/utils";

interface WhatsAppButtonProps {
  phoneNumber?: string;
  message?: string;
  className?: string;
}

export default function WhatsAppButton({
  phoneNumber = "573218997794",
  message = "Hola, me gustaría recibir más información sobre los servicios de SYCMA. https://sycmahg.com",
  className,
}: WhatsAppButtonProps) {
  const handleClick = () => {
    const encodedMessage = encodeURIComponent(message);
    window.open(
      `https://wa.me/${phoneNumber}?text=${encodedMessage}`,
      "_blank"
    );
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        "fixed bottom-6 right-6 z-50 p-4 bg-[#25D366] text-white rounded-full shadow-lg",
        "hover:bg-[#20BA5C] hover:shadow-xl hover:-translate-y-1",
        "transition-all duration-300",
        "flex items-center justify-center",
        className
      )}
      aria-label="Contactar por WhatsApp"
    >
      <MessageCircle className="h-6 w-6" />
    </button>
  );
}
